// css =>
import "../../BaseStructure.css";
import Styled from "./landing-page.module.css";

// componenets =>
import Menu from "../../components/menu/menu.comp";
import Fotter from "../../components/fotter/fotter.comp";
import PlantBox from "../../components/plant-box/plant-box.comp";
import ServiceBox from "../../components/service-box/service-box.comp";
import StoryViewer from "../../components/story-viewer/story-viewer.comp";
import ProjectTittleBox from "../../components/project-tittle-box/project-tittle-box.comp";
import ProjectPictureBox from "../../components/project-picture-box/project-picture-box.comp";

// icons =>
import WmIconDay from "../../assets/icons/wm1-day.png";
import WmIconNight from "../../assets/icons/wm1-night.png";

import Icon1 from "../../assets/icons/pic_1.png";
import Icon2 from "../../assets/icons/pic_2.png";
import Icon3 from "../../assets/icons/pic_3.png";
import Icon4 from "../../assets/icons/pic_4.png";
import Icon5 from "../../assets/icons/pic_5.png";
import Icon6 from "../../assets/icons/pic_6.png";

import Icon1Day from "../../assets/icons/pic_1_day.png";
import Icon3Day from "../../assets/icons/pic_3_day.png";
import Icon4Day from "../../assets/icons/pic_4_day.png";
import Icon5Day from "../../assets/icons/pic_5_day.png";
import Icon6Day from "../../assets/icons/pic_6_day.png";

import InstaIcon from "../../assets/icons/insta-icon.png";
import EmailIcon from "../../assets/icons/email-icon.png";
import WharsappIcon from "../../assets/icons/whatsapp-icon.png";
import LocationIcon from "../../assets/icons/location-icon.png";

import InstaIconDay from "../../assets/icons/insta-icon-day.png";
import EmailIconDay from "../../assets/icons/email-icon-day.png";
import WharsappIconDay from "../../assets/icons/whatsapp-icon-day.png";
import LocationIconDay from "../../assets/icons/location-icon-day.png";

// pictures =>
import hero from "../../assets/pictures/hero.webp";
import Pic2 from "../../assets/pictures/pic_2.jpg";
import Pic3 from "../../assets/pictures/pic_3.jpg";
import Pic4 from "../../assets/pictures/pic_4.jpg";
import Pic5 from "../../assets/pictures/pic-5.jpg";
import Pic6 from "../../assets/pictures/pic-6.jpg";

import Pic7 from "../../assets/pictures/pic_7.webp";
import Pic8 from "../../assets/pictures/pic_8.webp";
import Pic9 from "../../assets/pictures/pic_9.webp";
import Pic11 from "../../assets/pictures/pic-11.webp";

// react =>
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

// services =>
import { getInsightsList, getInsightsStoryList } from "./landing-page-service";

// animation =>
import AOS from 'aos';

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';
import { getTranslatedField } from '../../utils/get-translated-field';

// context =>
import { useTheme } from '../../context/theme-context';

function LandingPage () {    
    const aboutUsRef = useRef(null);
    const servicesRef = useRef(null);
    const contactUsRef = useRef(null);
    const { theme, toggleTheme } = useTheme();

    const scrollMap = {
        services: servicesRef,
        about: aboutUsRef,
        contact: contactUsRef
    };

    const location = useLocation();
    const navigate = useNavigate();

    const { language } = useLanguage();
    const t = (key) => getTranslation(language, key);

    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(1);

    const [alreadyIndex, setAlreadyIndex] = useState(0);
    const [selectedProjectsItemIndex, setSelectedProjectsItemIndex] = useState(0);

    const [insightsList, setInsightsList] = useState([]);
    const [insightsStoryList, setInsightsStoryList] = useState([]);

    useEffect(() => {
        document.title = "برگ سبز | رویش ایده‌های نو، ساختن آینده‌ای سبز";

        if (location.state?.scrollTo) {
            const timer = setTimeout(() => {
                handleScroll(location.state.scrollTo);
                navigate(location.pathname, { replace: true, state: {} });
            }, 400);

            return () => clearTimeout(timer);
        }
    }, [location.state, navigate, location.pathname]);

    useEffect(() => {
        const refreshAnimation = window.requestAnimationFrame(() => {
            AOS.refreshHard();
        });

        const fetchInsights = async () => {
            const data = await getInsightsList();
            setInsightsList(data);
        };
        
        fetchInsights();
        return () => window.cancelAnimationFrame(refreshAnimation);
    }, []);

    useEffect(() => {
        const id = insightsList[alreadyIndex]?.id;
        if (!id) return;

        const fetchInsightsStory = async () => {
            const data = await getInsightsStoryList(id);
            setInsightsStoryList(data);
        };

        fetchInsightsStory();
    }, [alreadyIndex, insightsList]);

    const handleScroll = (targetKey) => {
        const targetRef = scrollMap[targetKey];
        if (targetRef && targetRef.current) {
            targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <>
            <div>
                {
                    open && (
                        <StoryViewer
                            stories={insightsStoryList.map(story => ({
                                id: story.id,
                                type: story.story_type,
                                url: story.file_url,
                                caption: story.caption,
                                username: 'Barg sabz',
                                duration: 5000,
                                avatarUrl: story.thumbnail,
                            }))}
                            initialIndex={ currentIndex }
                            onClose={() => setOpen(false)}
                        />
                    )
                }
            </div>

            <Menu
                onScrollTo={ handleScroll }
            />

            <header>
                <div className={`row ${ Styled.header_box } `} data-aos="fade-up">
                    <div className={`col-12 ${ Styled.IntroductionBox } `}>
                        <img src={
                            theme === "day" ? WmIconDay : WmIconNight
                        } alt="wm" />
                        <h1
                            style={{
                                color: theme === "day" ? "#456700" : "",
                            }}
                        >{ t('headerTitle1') }</h1>
                        <p
                            style={{
                                color: theme === "day" ? "#456700" : "",
                            }}>{ t('headerTitle2') }</p>
                    </div>

                    <div className={`col-12 ${ Styled.ServicesBox } `} >
                        <div></div>
                        <img src={ hero } alt="pic_1" />
                        <br />
                        <button style={{
                            backgroundColor: theme === "day" ? "#778066" : ""
                        }}>
                            <p
                                style={{
                                    color: theme === "day" ? "#FFFFFF" : ""
                                }}
                            >{ t('bodyOurServicesHeader') }</p>
                        </button>
                    </div>
                </div>
            </header>

            <main>
                <div className={`row ${ Styled.services_button_box } `} data-aos="fade-up">
                    <div className="col-12">
                        <button
                            style={{
                                backgroundColor: theme === "day" ? "#778066" : "",
                                color: theme === "day" ? "#FFFFFF" : ""
                            }}>{ t('bodyOurServicesHeader') }</button>
                    </div>
                </div>

                <div className={`row ${ Styled.ServicesBoxFrame } `} ref={ servicesRef }>
                    <ServiceBox
                        index={ 1 }
                        serviceIcon={ Icon2 }
                        serviceTittle={ t('bodyOurServicesBodyOption1') }

                        iconWidth={ 35 }
                        iconHeight={ 26 }

                        desktopIconWidth={ 70 }
                        desktopIconHeight={ 51 }
                    />
                    <ServiceBox
                        index={ 0 }
                        serviceIcon={
                            theme === "day" ? Icon1Day : Icon1
                        }
                        serviceTittle={ t('bodyOurServicesBodyOption2') }

                        iconWidth={ 35 }
                        iconHeight={ 32 }

                        desktopIconWidth={ 70 }
                        desktopIconHeight={ 63 }
                    />

                    <ServiceBox
                        index={ 3 }
                        serviceIcon={
                            theme === "day" ? Icon4Day : Icon4
                        }
                        serviceTittle={ t('bodyOurServicesBodyOption3') }

                        iconWidth={ 25 }
                        iconHeight={ 34 }

                        desktopIconWidth={ 50 }
                        desktopIconHeight={ 68 }
                    />
                    <ServiceBox
                        index={ 2 }
                        serviceIcon={
                            theme === "day" ? Icon3Day : Icon3
                        }
                        serviceTittle={ t('bodyOurServicesBodyOption4') }

                        iconWidth={ 35 }
                        iconHeight={ 30 }

                        desktopIconWidth={ 70 }
                        desktopIconHeight={ 59 }
                    />

                    <ServiceBox
                        index={ 5 }
                        serviceIcon={
                            theme === "day" ? Icon6Day : Icon6
                        }
                        serviceTittle={ t('bodyOurServicesBodyOption5') }

                        iconWidth={ 25 }
                        iconHeight={ 24 }

                        desktopIconWidth={ 55 }
                        desktopIconHeight={ 53 }
                    />
                    <ServiceBox
                        index={ 4 }
                        serviceIcon={
                            theme === "day" ? Icon5Day : Icon5
                        }
                        serviceTittle={ t('bodyOurServicesBodyOption6') }

                        iconWidth={ 25 }
                        iconHeight={ 26 }

                        desktopIconWidth={ 60 }
                        desktopIconHeight={ 61 }
                    />
                </div>

                <div className="row">
                    <div className={`col-12 ${ Styled.PlantsButtonBox } `}>
                        <button
                            style={{
                                backgroundColor: theme === "day" ? "#778066" : ""
                            }}>
                            <div onClick={() => navigate("/products")}
                                style={{
                                    backgroundColor: theme === "day" ? "#E6E6E6" : "",
                                    float: language === "fa" ? "left" : ""
                                }}>
                                <p
                                    style={{
                                        color: theme === "day" ? "#2E3324" : ""
                                    }}>{ t('bodyViewAllButton') }</p>
                            </div>
                            <p
                                style={{
                                    color: theme === "day" ? "#FFFFFF" : ""

                                }}>{ t('bodyPlantsHeader') }</p>
                        </button>
                    </div>

                    <div className={`row ${ Styled.PlantsBox } `}>
                        <PlantBox index={ 0 } plantPicture={ Pic4 } plantTittle={ t('bodyPlantsBodyOption1') } />
                        <PlantBox index={ 1 } plantPicture={ Pic3 } plantTittle={ t('bodyPlantsBodyOption2') } />
                        <PlantBox index={ 2 } plantPicture={ Pic2 } plantTittle={ t('bodyPlantsBodyOption3') } />
                        <PlantBox index={ 3 } plantPicture={ Pic5 } plantTittle={ t('bodyPlantsBodyOption4') } />
                        <PlantBox index={ 4 } plantPicture={ Pic6 } plantTittle={ t('bodyPlantsBodyOption5') } />
                    </div>
                </div>

                <div className="row">
                    <div className={`col-12 ${ Styled.ProjctsButtonBox } `}>
                        <button style={{
                            backgroundColor: theme === "day" ? "#778066" : ""
                        }}>
                            <div
                                onClick={() => navigate("/portfolio")}
                                style={{
                                    backgroundColor: theme === "day" ? "#E6E6E6" : "",
                                    float: language === "fa" ? "left" : ""
                                }}>
                                <p
                                    style={{
                                        color: theme === "day" ? "#2E3324" : ""
                                    }}>{ t('bodyViewAllButton') }</p>
                            </div>

                            <p
                                style={{
                                    color: theme === "day" ? "#FFFFFF" : ""
                                }}>{ t('bodyProjectsHeader') }</p>
                        </button>
                    </div>

                    <div className={`col-12 ${ Styled.ProjectsTittleBox } `}>
                        <ProjectTittleBox
                            index={ 0 }
                            projectTittle={ t('bodyProjectsBodyOption1') }
                            selectedItemIndex={ selectedProjectsItemIndex }
                            onClick={() => setSelectedProjectsItemIndex(0)}
                        />
                        <ProjectTittleBox
                            index={ 1 }
                            projectTittle={ t('bodyProjectsBodyOption2') }
                            selectedItemIndex={ selectedProjectsItemIndex }
                            onClick={() => setSelectedProjectsItemIndex(1)}
                        />
                        <ProjectTittleBox
                            index={ 2 }
                            projectTittle={ t('bodyProjectsBodyOption3') }
                            selectedItemIndex={ selectedProjectsItemIndex }
                            onClick={() => setSelectedProjectsItemIndex(2)}
                        />
                        <ProjectTittleBox
                            index={ 3 }
                            projectTittle={ t('bodyProjectsBodyOption4') }
                            selectedItemIndex={ selectedProjectsItemIndex }
                            onClick={() => setSelectedProjectsItemIndex(3)}
                        />
                        <ProjectTittleBox
                            index={ 4 }
                            projectTittle={ t('bodyProjectsBodyOption5') }
                            selectedItemIndex={ selectedProjectsItemIndex }
                            onClick={() => setSelectedProjectsItemIndex(4)}
                        />
                    </div>

                    <div className={`col-12 ${ Styled.ProjectsPictureBox } `}>
                        <ProjectPictureBox index={ 0 } projectPicture={ Pic7 } />
                        <ProjectPictureBox index={ 1 } projectPicture={ Pic8 } />
                        <ProjectPictureBox index={ 2 } projectPicture={ Pic9 } />
                    </div>
                </div>

                <div className="row">
                    <div className={`col-12 ${ Styled.GreenJournalBox } `}>
                        <button
                            style={{
                                backgroundColor: theme === "day" ? "#778066" : ""
                            }}>
                            <p
                               style={{
                                    color: theme === "day" ? "#FFFFFF" : ""
                                }}>{ t('bodyGreenJournalHeader') }</p>
                        </button>
                    </div>

                    <div
                        className={`row ${ Styled.GreenJournalInfoBox } `}
                        style={{ 
                            backgroundColor: theme === "day" ? "#C9CCC2" : "",
                        }}>
                        <div className={`row ${ Styled.GreenJournalBoxHeader } `}>
                            {
                                insightsList && insightsList.length > 0 ? (
                                        <>
                                            <div className="col-5"
                                                style={{
                                                    float: language === "fa" ? "left" : "",
                                                }}>
                                                {
                                                    insightsStoryList && insightsStoryList.length > 0 ? (
                                                        <div style={{
                                                            marginLeft: language === "fa" ? "15px" : "",
                                                            float: language === "fa" ? "left" : "",
                                                        }}>
                                                            {
                                                                insightsStoryList.map((item, index) => {
                                                                    return (
                                                                        <div
                                                                            key={ item.id }
                                                                            className={`col-4 ${ Styled.StoryBox } `}
                                                                            style={{
                                                                                borderColor: theme === "day" ? "#AAFF00" : "",
                                                                                float: language === "fa" ? "left" : ""
                                                                            }}
                                                                            onClick={() => {
                                                                                setCurrentIndex(index);
                                                                                setOpen(true);
                                                                            }}>
                                                                            <img src={ item.thumbnail } alt="" loading="lazy" />
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    ) : <p className={ Styled.no_content_text }>{ t('noContent') }</p>
                                                }
                                            </div>

                                            <div className={`col-6 ${ Styled.GreenJournalBoxHeaderTextAndSlideBox } `}>
                                                <div className="col-2">
                                                    <div
                                                        style={{
                                                            transform: "rotate(90deg)",
                                                            backgroundColor: theme === "day" ? "#C9CCC2" : ""
                                                        }}
                                                        className={ Styled.SlideShapeButton } onClick={() => {
                                                        if (alreadyIndex < insightsList.length - 1) {
                                                            setAlreadyIndex(alreadyIndex + 1);
                                                        }
                                                    }}></div>
                                                </div>
                                                <div className="col-8">
                                                    <p>
                                                        {
                                                            getTranslatedField(insightsList[alreadyIndex], 'title', language)
                                                        }
                                                    </p>
                                                </div>
                                                <div className="col-2">
                                                    <div
                                                        style={{
                                                            backgroundColor: theme === "day" ? "#C9CCC2" : ""
                                                        }}
                                                        className={ Styled.SlideShapeButton } onClick={() => {
                                                        if (alreadyIndex >= 1) {
                                                            setAlreadyIndex(alreadyIndex - 1);
                                                        }
                                                    }}></div>
                                                </div>
                                            </div>
                                        </>
                                ) : (
                                    <p className={ Styled.no_content_text }>{ t('noContent') }</p>
                                )
                            }
                        </div>

                        <div className="col-12">
                            <p
                                style={{
                                    color: theme === "day" ? "#000000" : ""
                                }}>
                                {
                                    insightsList && insightsList.length > 0 ? (
                                        getTranslatedField(insightsList[alreadyIndex], 'description', language)
                                    ) : (
                                        t('noContent')
                                    )
                                }
                            </p>
                        </div>
                    </div>
                </div>

                <div className={`row ${ Styled.about_barge_sabz_box } `}>
                    <div className={`col-12 ${ Styled.about_barge_sabz_header_box } `} ref={ aboutUsRef }>
                        <button
                            style={{
                                backgroundColor: theme === "day" ? "#778066" : ""
                            }}>
                            <p
                                style={{
                                    color: theme === "day" ? "#FFFFFF" : ""
                                }}>{ t('bodyAboutBargeSabzHeader') }</p>
                        </button>
                    </div>

                    <div className="col-12">
                        <img src={ Pic11 } alt="" loading="lazy" />
                    </div>

                    <div className={`col-12 ${ Styled.about_barge_sabz_tittle_box } `}>
                        <button style={{
                            backgroundColor: theme === "day" ? "#777F66" : ""
                        }}>
                            <p>{ t('bodyAboutBargeSabzTitle') }</p>
                        </button>
                    </div>

                    <div
                        className={`col-12 ${ Styled.about_barge_sabz_body_box } `}
                        style={{
                            backgroundColor: theme === "day" ? "#C9CCC2" : ""
                        }}>
                        <p
                            style={{
                                color: theme === "day" ? "#000000" : ""
                            }}>
                            {t('bodyAboutBargeSabzBody')}
                        </p>
                    </div>
                </div>
            </main>

            <footer>
                <div className={`row ${ Styled.contact_us_box } `} ref={ contactUsRef }>
                    <div className={`col-12 ${ Styled.contact_us_header_box } `}>
                        <button
                            style={{
                                backgroundColor: theme === "day" ? "#778066" : ""
                            }}>
                            <p
                            style={{
                                color: theme === "day" ? "#FFFFFF" : ""
                            }}>{ t('fotterContactUsHeader') }</p>
                        </button>
                    </div>

                    <div className="col-6">
                        <div
                            className={ Styled.contact_id_box }
                            style={{
                                backgroundColor: theme === "day" ? "#C9CCC2" : "",
                            }}>
                            <p
                                style={{
                                    color: theme === "day" ? "#000000" : ""
                                }}>Baargesabz</p>
                        </div>

                        <div 
                            className={ Styled.contact_icon_box }
                            style={{
                                borderColor: theme === "day" ? '#334C00' : ""
                            }}>
                            <img src={
                                theme === "day" ? InstaIconDay : InstaIcon
                            } alt="اینستاگرام" loading="lazy" />
                        </div>
                    </div>
                        <div className="col-6">
                            <a href="tel:09336082855">
                                <div
                                    className={ Styled.contact_id_box }
                                    style={{
                                        backgroundColor: theme === "day" ? "#C9CCC2" : "",
                                    }}>
                                    <p
                                        style={{
                                            color: theme === "day" ? "#000000" : ""
                                        }}>09141234567</p>
                                </div>

                                <div
                                    className={ Styled.contact_icon_box }
                                    style={{
                                        borderColor: theme === "day" ? '#334C00' : ""
                                    }}>
                                    <img src={
                                        theme === "day" ? WharsappIconDay : WharsappIcon
                                    } alt="واتساپ" loading="lazy" />
                                </div>
                            </a>
                        </div>

                    <div className="col-6" style={{ marginTop: '20px' }}>
                        <a href="mailto:bargesabzcompany@gmail.com">
                            <div 
                                className={ Styled.contact_id_box }
                                style={{
                                    backgroundColor: theme === "day" ? "#C9CCC2" : "",
                                }}>
                                <p
                                    className={ Styled.email_text }
                                    style={{
                                        color: theme === "day" ? "#000000" : ""
                                    }}>bargesabzcompany@gmail.com</p>
                            </div>

                            <div
                                className={ Styled.contact_icon_box }
                                style={{
                                        borderColor: theme === "day" ? '#334C00' : ""
                                }}>
                                <img className={ Styled.email_icon } src={
                                    theme === "day" ? EmailIconDay : EmailIcon
                                } alt="ایمیل" loading="lazy" />
                            </div>
                        </a>
                    </div>
                    <div className="col-6" style={{ marginTop: '20px' }}>
                        <div
                            className={ Styled.contact_id_box }
                            style={{
                                backgroundColor: theme === "day" ? "#C9CCC2" : "",
                            }}>
                            <p
                                style={{
                                    color: theme === "day" ? "#000000" : ""
                                }}>Urmia . Emamzadeh .st</p>
                        </div>

                        <div
                            className={ Styled.contact_icon_box }
                            style={{
                                borderColor: theme === "day" ? '#334C00' : ""
                            }}>
                            <img src={
                                theme === "day" ? LocationIconDay : LocationIcon
                            } alt="مکان" loading="lazy" />
                        </div>
                    </div>
                </div>
                <Fotter />
            </footer>
        </>
    );
}

export default LandingPage;
